import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import ContractorForm from '@views/contractors/ContractorForm';

export class ContractorUpdateForm extends FormView {
    protected getFormComponent() {
        return ContractorForm;
    }
}

export default ContractorUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(ContractorUpdateForm));
